<template>
  <div class="flex flex-col gap-2 pb-2">
    <div v-for="option in options" :key="option.id">
      <InputRadio
        :id="option.id" :name="option.name" :value="option.value"
        :label="option.label" :model-value="newComponentStore.newComponent.interval"
        @update:model-value="newComponentStore.newComponent.interval = $event as CumulInterval"
        :description="option.value === smartDefault
          ? `${option.description} · ${t('newcomponent.interval.recommended')}`
          : option.description" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { CumulInterval } from '../../SalesReport'
import { useNewComponentStore } from '../../stores/newComponentStore'
import { useI18n } from 'vue-i18n'
import InputRadio from './input/InputRadio.vue'
import { getSmartTimeAggregation } from '../../types/customCharts'

const { t } = useI18n()
const newComponentStore = useNewComponentStore()

const smartDefault = computed<CumulInterval>(() => {
  const start = newComponentStore.newComponent.customStartDate
  const end = newComponentStore.newComponent.customEndDate
  if (start && end) {
    return getSmartTimeAggregation(new Date(start), new Date(end)) as CumulInterval
  }
  return 'day'
})

const options = computed(() => [
  {
    id: 'day',
    name: 'interval',
    value: 'day' as CumulInterval,
    label: t('newcomponent.interval.day'),
    description: t('newcomponent.interval.day_description')
  },
  {
    id: 'week',
    name: 'interval',
    value: 'week' as CumulInterval,
    label: t('newcomponent.interval.week'),
    description: t('newcomponent.interval.week_description')
  },
  {
    id: 'month',
    name: 'interval',
    value: 'month' as CumulInterval,
    label: t('newcomponent.interval.month'),
    description: t('newcomponent.interval.month_description')
  },
  {
    id: 'year',
    name: 'interval',
    value: 'year' as CumulInterval,
    label: t('newcomponent.interval.year'),
    description: t('newcomponent.interval.year_description')
  }
])

onMounted(() => {
  newComponentStore.newComponent.interval = smartDefault.value
})
</script>
